import type { ReactNode } from "react";
import {
  decisionSectionHeading,
  type DecisionSectionKey,
} from "@/lib/decision-sections";

// TES-1291 (TES-1267 §4) — one of the six numbered sections a treatment
// decision is made in (see decision-sections.ts).
export function DecisionSection({
  section,
  testId,
  children,
}: {
  section: DecisionSectionKey;
  testId?: string;
  children: ReactNode;
}) {
  const headingId = `${testId ?? "decision"}-${section}-heading`;
  return (
    <section
      aria-labelledby={headingId}
      data-testid={testId ? `${testId}-${section}` : undefined}
      className="flex flex-col gap-sm rounded-md border border-surfaceMuted p-sm"
    >
      <h3 id={headingId} className="text-sm font-semibold text-textPrimary">
        {decisionSectionHeading(section)}
      </h3>
      {children}
    </section>
  );
}
